import { Injectable, Injector } from '@angular/core';
import { BaseService } from 'src/app/common/base/base.service';
import { ScheduleSubdetailNote } from '../models/schedule-note';

@Injectable({
  providedIn: 'root'
})
export class ScheduleSubdetailNoteService extends BaseService<ScheduleSubdetailNote, number> {

  constructor(protected override injector: Injector,) {
    super(injector, '/schedule_subdetail_note');
  }

}
